import { render, staticRenderFns } from "./MessageBody.vue?vue&type=template&id=5669d0ea&"
import script from "./MessageBody.vue?vue&type=script&lang=js&"
export * from "./MessageBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports